import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgHome({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 20v-5.75C9 12.48 10.315 11 12 11s3 1.48 3 3.25V20h2a1 1 0 001-1v-5a1 1 0 112 0v5a3 3 0 01-3 3H7a3 3 0 01-3-3v-5a1 1 0 112 0v5a1 1 0 001 1h2zm2 0h2v-5.75c0-.715-.476-1.25-1-1.25s-1 .535-1 1.25V20zm1-18c.256 0 .512.098.707.293l9 9a1 1 0 01-1.414 1.414L12 4.414l-8.293 8.293a1 1 0 01-1.414-1.414l9-9A.997.997 0 0112 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgHome
